/**
 * A page-URL query flag, decoded and trimmed. Absent, key-only or blank (`?replay`, `?replay=`, `?replay=%20`) reads
 * as null, so an empty value never stands in for a round id, a device or an operator.
 */
export function readQueryParam(queryString: string | null | undefined, key: string): string | null {
  const value = new URLSearchParams(queryString ?? "").get(key)?.trim();
  return value || null;
}
